import { FormBase } from 'core/components';
import moment from 'moment';
import validatorjs from 'validatorjs';

export default class ShipmentCostForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		var Validator = validatorjs;
		Validator.register(
			'dateFormat',
			value => {
				return moment(value, 'MM/DD/YYYY', true).isValid();
			},
			'INVALIDDATEFORMAT'
		);
		return {
			fields: [
				{
					name: 'dateRangeStart',
					label: 'SHIPMENTCOST.DATERANGESTART',
					rules: 'required|dateFormat',
				},
				{
					name: 'dateRangeEnd',
					label: 'SHIPMENTCOST.DATERANGEEND',
					rules: 'dateFormat',
				},
				{
					name: 'carrier',
					label: 'SHIPMENTCOST.CARRIER',
					rules: 'required',
				},
				{
					name: 'searchTrackingNumber',
					placeholder: 'SEARCHTRACKINGNUMBER',
					value: '',
				},
				{
					name: 'showOnlyDiscrepancies',
					label: 'SHIPMENTCOST.SHOWONLYDISCREPANCIES',
					value: false,
				},
				{
					name: 'showOnlyOvercharged',
					label: 'SHIPMENTCOST.OVERCHARGED',
					value: false,
				},
				{
					name: 'showOnlyUndercharged',
					label: 'SHIPMENTCOST.UNDERCHARGED',
					value: false,
				},
				{
					name: 'showOnlyWithBilling',
					label: 'SHIPMENTCOST.SHOWONLYWITHBILLING',
					value: true,
				},
			],
		};
	}
	options() {
		return {
			validateOnBlur: false,
			showErrorsOnReset: false,
			validateOnChange: false,
			validateOnChangeAfterSubmit: true,
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/shipment-cost/forms/ShipmentCostForm.js